/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { object } from "prop-types";
import get from "lodash/get";

import Headline from "../atoms/headline";
import LoadMoreSearchResults from "../molecules/load-more-search-results";
import DfpAd from "../dfp-ad";
import SideBar from "./section/sidebar";

import "./search.m.css";

class SearchPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: null
    };
  }
  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();
  }

  render() {
    const { data } = this.props;
    const headlineText = `Search - ${data.query ? data.query : ""}`;

    const searchHeadline = () => (
      <div styleName="search-header">
        <Headline text={headlineText} headerType={12} headerLevel={1} />
      </div>
    );

    const trendingCollection = get(data, ["trendingCollection", "collection"], {});
    const webSpecialCollection = get(data, ["webSpecialCollection", "collection"], {});
    const opinionsCollection = get(data, ["opinionsCollection", "collection"], {});
    const horoscopeCollection = get(data, ["horoscopeCollection", "collection"], {});
    const viralCollection = get(data, ["viralCollection", "collection"], {});

    return (
      <div styleName="wrapper">
        {this.state.width <= 992 && (
          <div className="dfp-ad">
            <DfpAd adtype="banner_2_300x100" />
          </div>
        )}
        <div>
          {searchHeadline()}
          <div styleName="stories-wrapper">
            <LoadMoreSearchResults data={data} itemsToLoad={10} />
            <div styleName="sidebar">
              <SideBar
                trendingCollection={trendingCollection}
                webSpecialCollection={webSpecialCollection}
                opinionsCollection={opinionsCollection}
                horoscopeCollection={horoscopeCollection}
                viralCollection={viralCollection}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export { SearchPage };

SearchPage.propTypes = {
  data: object
};
